import React, { Component } from 'react';
import EWH from '../components/EWH';
import { useParams } from "react-router-dom";

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}


export class RegioneComunali2026 extends Component {
  render() {
    let { regione} = this.props.params;
    let repoDettaglio2026 = "/elezioni/withub/comunali-2026/comunali/" + regione + "/" + regione + ".html";
    let repoFascione2026 = "/elezioni/withub/comunali-2026/comunali/fascione-osservati.html";
    return (
    <div className="App">
        <EWH id="ewh-dettaglio" repo={repoDettaglio2026} />
        <EWH id="ewh-fascione" repo={repoFascione2026} />
    </div>
    )
  }
}

export default withParams(RegioneComunali2026)
